/**
 * Generated by scripts/generate-build-version.ts — do not edit by hand.
 * Identifies the build this bundle was produced from, for comparison against its environment-specific version document.
 */
export const BUILD_VERSION: string = '1.0.3';
